/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IPC_COLLECT_LOGS: BridgeCommands.Command<
    Types.Common.Backgroundagent.IPC_COLLECT_LOGSParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'BackgroundAgent',
    method: 'IPC_COLLECT_LOGS',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IPC_UPLOAD_EXCEPTION_INFO: BridgeCommands.Command<
    Types.Common.Backgroundagent.IPC_UPLOAD_EXCEPTION_INFOParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'BackgroundAgent',
    method: 'IPC_UPLOAD_EXCEPTION_INFO',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IPC_CLIENT_HEARTBEAT: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'BackgroundAgent',
    method: 'IPC_CLIENT_HEARTBEAT',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IPC_GFN_REMOTE_CONFIG_UPDATED_EVENT: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'BackgroundAgent',
    method: 'IPC_GFN_REMOTE_CONFIG_UPDATED_EVENT',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IPC_CHECK_FOR_UPDATE: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'BackgroundAgent',
    method: 'IPC_CHECK_FOR_UPDATE',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IPC_GET_SELF_UPDATE_STATUS: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'BackgroundAgent',
    method: 'IPC_GET_SELF_UPDATE_STATUS',
    persistent: false
};

export const Backgroundagent = {
IPC_COLLECT_LOGS,
IPC_UPLOAD_EXCEPTION_INFO,
IPC_CLIENT_HEARTBEAT,
IPC_GFN_REMOTE_CONFIG_UPDATED_EVENT,
IPC_CHECK_FOR_UPDATE,
IPC_GET_SELF_UPDATE_STATUS
};
